import React from 'react'
import '../PopularItem/PopularItem.css'
import Pic1 from '../../Image/pic-1.webp'
import Pic2 from '../../Image/pic-2.webp'
import Pic3 from '../../Image/pic-3.webp'
function PopularItem() {
  return (
    <>
    <div className='pop-bg-color'>
       <h2 className='popular-head-text'>Popular Item <i class="fa-solid fa-fire"></i></h2>
    <div className='PopularItem'>
      <div>
        <img src={Pic1} alt="" srcset="" />
        <p>Chicken Wings Rice Bowl</p>
        <span>Price: 250  ৳</span> <br /><br />
        {/* <span>Price: 666 ৳ | 1:5 </span><br /><br /> */}
        <i class="fa-solid fa-fire"> hot sale </i>
      </div>
      <div>
        <img src={Pic2} alt="" srcset="" />
        <p>Butter Milk Chicken</p>
        <span>Price: 480 ৳</span><br /><br />
        <i class="fa-solid fa-fire"> Continental Food </i>
      </div>
      <div>
        <img src={Pic3} alt="" srcset="" />
        <p>Couple Platter</p>
        <span>Price: 999 ৳</span><br /><br />
        <i class="fa-solid fa-fire"> Couple Zone Special </i>
      </div>
    </div> 
    </div>
  
    </>
  )
}

export default PopularItem